<template>
<div class="chapter">
<div class="inner_page">
<p class="SP1" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="FMTNI">A sincere thank-you to Linda Chester, Sara Goodman, and the wonderful people at St. Martin’s Press.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?60d0384c